export enum Bound {
  LOWER = 'LOWER',
  UPPER = 'UPPER',
}
